import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SebbieOverviewComponent } from './sebbie-overview/sebbie-overview.component';
import { UserListComponent } from './_components/user-list/user-list.component';
import { UserCardComponent } from './_components/user-card/user-card.component';
import { HeaderContentComponent } from './_components/header-content/header-content.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { TaskDetailComponent } from './task-detail/task-detail.component';
import { HeaderContentTaskComponent } from './_components/header-content-task/header-content-task.component';
import { TaskCardComponent } from './_components/task-card/task-card.component';
import { TaskDetailDialogComponent } from './_components/task-detail-dialog/task-detail-dialog.component';
import { PromotionDetailDialogComponent } from './_components/promotion-detail-dialog/promotion-detail-dialog.component';
import { PromotionHistoryComponent } from './_components/promotion-history/promotion-history.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';

@NgModule({
  declarations: [
    SebbieOverviewComponent,
    UserListComponent,
    UserCardComponent,
    HeaderContentComponent,
    TaskDetailComponent,
    HeaderContentTaskComponent,
    TaskCardComponent,
    TaskDetailDialogComponent,
    PromotionDetailDialogComponent,
    PromotionHistoryComponent,
  ],
  imports: [CommonModule, ComponentsModule, InfiniteScrollDirective],
  exports: [SebbieOverviewComponent],
})
export class SebbiesModule {}
